// src/features/dashboard/services/manager/teamActiveHoursTeamLeadsApi.ts

import api from '../../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../../api/endpoints';


// ============================================================================
// TEAM LEADER
// ============================================================================

export interface TeamLeader {
  employeeCode: string;
  employeeName: string;
}


// ============================================================================
// REQUEST
// ============================================================================

export interface TeamActiveHoursTeamLeadsRequest {
  managerEmployeeCode: string;
}


// ============================================================================
// API RESPONSE
// ============================================================================

interface TeamActiveHoursTeamLeadsApiResponse {
  employeeCode: string;
  fullName: string;
  email: string;
  country: string;
  city: string;
  department: string;
}


// ============================================================================
// GET TEAM LEADS
// ============================================================================

export const getTeamActiveHoursTeamLeads =
  async (
    managerEmployeeCode: string,
  ): Promise<TeamLeader[]> => {

    const token =
      sessionStorage.getItem('token') ||
      localStorage.getItem('token');


    // ========================================================================
    // REQUEST BODY
    // ========================================================================

    const requestBody:
      TeamActiveHoursTeamLeadsRequest = {
        managerEmployeeCode:
          managerEmployeeCode || '',
      };


    // ========================================================================
    // API CALL
    // ========================================================================

    const response =
      await api.post<
        TeamActiveHoursTeamLeadsApiResponse[]
      >(
        ENDPOINTS.TEAM_ACTIVE_HOURS_TEAM_LEADS,

        requestBody,

        {
          headers: {
            Authorization: token
              ? `Bearer ${token}`
              : '',
          },
        },
      );


    // ========================================================================
    // LOG REQUEST
    // ========================================================================

    console.log(
      'TEAM_ACTIVE_HOURS_TEAM_LEADS REQUEST:',
      requestBody,
    );


    // ========================================================================
    // LOG RESPONSE
    // ========================================================================

    console.log(
      'TEAM_ACTIVE_HOURS_TEAM_LEADS RESPONSE:',
      response.data,
    );


    // ========================================================================
    // MAP API RESPONSE
    //
    // API returns:
    // {
    //   employeeCode: "SG377854",
    //   fullName: "Deepak Rohilla",
    //   ...
    // }
    //
    // Dropdown expects:
    // {
    //   employeeCode: "SG377854",
    //   employeeName: "Deepak Rohilla"
    // }
    // ========================================================================

    const teamLeaders: TeamLeader[] =
      response.data.map(
        (item) => ({
          employeeCode:
            item.employeeCode,

          employeeName:
            item.fullName,
        }),
      );


    // ========================================================================
    // LOG MAPPED DATA
    // ========================================================================

    console.log(
      'TEAM_ACTIVE_HOURS_TEAM_LEADS MAPPED:',
      teamLeaders,
    );


    return teamLeaders;
  };